<app-navbar></app-navbar>
<router-outlet />
<app-footer ></app-footer>

<!-- Toast globale per notifiche PEC -->
<p-toast position="top-right"></p-toast>
